import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { FiCheckSquare, FiInfo, FiLoader, FiSend } from "react-icons/fi";
import { requestPointsClaimApi } from "./ClaimListCard.api";
import { toastrError, toastrSuccess } from "lib/toastr";
import { useTranslation } from "react-i18next";

const ClaimListCard = ({
  claimList,
  refreshList,
  setClaimList,
}: {
  claimList: any;
  refreshList: any;
  setClaimList: any;
}) => {
  const { t } = useTranslation();
  const [totalPoints, setTotalPoints] = useState<number>(0);
  //handle insertion
  const insertToClaimList = useMutation(
    (payload: any) => {
      return requestPointsClaimApi.insertPoints(payload);
    },
    {
      onError: (err: any) => {
        if (err) {
          toastrError("Something went wrong! Please try again later");
        }
      },
      onSuccess: (response: any) => {
        //todo: handle sucessful response
        setClaimList([]);
        refreshList();
        if (response) {
          toastrSuccess("Claim request sent successfully!");
        }
      },
    }
  );

  const handleList = () => {
    return (
      <div className="flex flex-col gap-1">
        <p className="text-sm text-ink-3">{t("claim.card.points")}</p>
        <p className="text-3xl font-bold tracking-tight font-display tabular-nums text-ink">{totalPoints}</p>
        <p className="text-xs text-ink-3">
          {claimList.length} {claimList.length === 1 ? "study" : "studies"} selected
        </p>
      </div>
    );
  };

  // Handle claimFunction
  function handleClaimFunction() {
    insertToClaimList.mutate(claimList);
  }

  // Calculate total points whenever claimList changes
  useEffect(() => {
    let sum = 0;
    claimList.forEach((item: any) => {
      sum += Number(item.points);
    });
    setTotalPoints(sum);
  }, [claimList]);

  const isDisabled = totalPoints < 1 || insertToClaimList.isLoading;

  return (
    <section className="zs-card">
      <div className="zs-card-header">
        <div className="flex items-center gap-3 min-w-0">
          <span className="zs-stat-icon">
            <FiCheckSquare />
          </span>
          <h2 className="zs-card-title">{t("claim.card.ClaimList")}</h2>
        </div>
      </div>
      <div className="flex flex-col gap-4 zs-card-body">
        <section className="p-4 border rounded-lg border-line bg-surface-2">
          {claimList.length ? handleList() : <p className="text-sm text-ink-3">{t("claim.card.study")}</p>}
        </section>
        <p className="flex items-start gap-2 text-xs leading-relaxed text-ink-3">
          <FiInfo className="mt-0.5 shrink-0 text-info" />
          <span>{t("claim.card.between")}</span>
        </p>
        <button
          disabled={isDisabled}
          className="zs-btn zs-btn-primary zs-btn-block"
          onClick={handleClaimFunction}
        >
          {insertToClaimList.isLoading ? (
            <>
              <FiLoader className="animate-spin" />
              <span>{t("claim.card.Loading")}</span>
            </>
          ) : (
            <>
              <FiSend />
              <span>{t("claim.card.Claim")}</span>
            </>
          )}
        </button>
      </div>
    </section>
  );
};

export default ClaimListCard;
